import React, { useState, useEffect } from 'react';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Button from 'react-bootstrap/Button';
import PropTypes from 'prop-types';
import { TitleBar, IconSelected, IconClose } from '../common/theme';
import { toArray } from '../../Utils';
import Spinner from '../common/generic/Spinner';
import Alert from 'react-bootstrap/Alert';

const LinkStudentComp = ({pageState}) => {
    const [classData,setClassData] = useState([]);
    const [studentData,setStudentData] = useState([]);
    
    useEffect(()=>{
        if((pageState.database['getAllClasses']) && pageState.database['getAllClasses'].isLoaded){
            let classes = [...toArray(pageState.database['getAllClasses'].data)]
                                .map(e=>{e.isSelected=false; return e;})
                                .sort((a,b) => (a.Classname.toUpperCase() > b.Classname.toUpperCase()) ? 1 : (a.Classname.toUpperCase() < b.Classname.toUpperCase() ? -1 : 0));
            let checkClass1 = JSON.stringify([...classData].map(e=>{return{...e, isSelected:false};}));
            let checkClass2 = JSON.stringify([...classes].map(e=>{e.isSelected=false; return e;}));
            if(checkClass1 != checkClass2) // only update the class list if the classes have changed
                setClassData(classes);
        }
    });

    useEffect(()=>{
        if((pageState.database['getStudentsForClassForLinkedStudentWindow']) && pageState.database['getStudentsForClassForLinkedStudentWindow'].isLoaded){
            pageState.database['getStudentsForClassForLinkedStudentWindow'].isLoaded = false;
            let students = [...toArray(pageState.database['getStudentsForClassForLinkedStudentWindow'].data)]
                                .map(e=>{e.isSelected=false; return e;})
                                .sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() < b.Name.toUpperCase() ? -1 : 0));
            setStudentData(students);
        }
    });

    return((!pageState.showLinkStudentsComp)?<></>:<div>
        <Row><Col xs={{ span: 6, offset: 6 }}><Alert variant='primary'><strong>Note:</strong> Students can only be linked to one class at a time</Alert></Col></Row>
        <Row>  
            <Col xs='6'><ClassTableComp data={{studentData, setStudentData,classData, setClassData}} pageState={pageState}/></Col>
            <Col xs='6'><StudentTableComp data={{studentData, setStudentData,classData,setClassData}} pageState={pageState} /></Col>
        </Row>
    </div>);
};

LinkStudentComp.propTypes = {
  pageState: PropTypes.object.isRequired,
};

const ClassTableComp = ({data, pageState}) => {
    
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='6'>Name</Col>
    </Row>;

    return (<>
        <Container>
            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'><h3>Select a Class</h3></Col>  
            </TitleBar>
        </Container>            
        <div style={{overflowY:'scroll', overflowX : 'hidden', height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
            {titleRow}
            {data.classData.map((classRec, i) => 
                <ClassRow key={i} classRec={classRec} data={data} pageState={pageState}/>
            )}
        </div>      
    </>
    );
};

ClassTableComp.propTypes = {
    data: PropTypes.object,
    pageState: PropTypes.object
};

const ClassRow = ({classRec, data, pageState}) => {
    const {Classname, ClassID, isSelected} = classRec;
    const [canSelect, setCanSelect] = useState(true);

    useEffect(()=>{
        if(pageState.showStudentTableComp.classInfo.ClassID === ClassID && canSelect){
            setCanSelect(false);
            if(isSelected){ // unselect this class if this is the class they are currently in
                let nextState = [...data.classData];
                nextState = nextState.map(e=>{return{...e, isSelected:false};});
                data.setClassData(nextState);
                data.setStudentData([]);
            }
        }
    });

    const rowStyle = {
        backgroundColor: (isSelected ? 'lightblue' : 'white'), 
        margin: '2px', 
        borderBottom: '1px solid #cfcfcf'
    };
    
    const select = (classID) => {
        let nextState = [...data.classData];
        let classIdx = nextState.findIndex(el => el.ClassID === classID);
        nextState = nextState.map(e=>{return{...e, isSelected:false};}); // don't allow users to choose more then one class at a time
        nextState[classIdx] = {...nextState[classIdx], isSelected: true};        
        data.setClassData(nextState);

        let getStudentsForClass={
            params: classID,
            func:'getStudentsForClass',
            altName: 'getStudentsForClassForLinkedStudentWindow'         
        };
        pageState.request(getStudentsForClass);
    };    

    return (
        <>
            <Row style={rowStyle}>
                {canSelect && <Col onClick={() => select(ClassID)} style={{paddingLeft: '2em', cursor: 'pointer', textAlign: 'left'}} xs='12'> {Classname} </Col>}
                {!canSelect && <Col style={{paddingLeft: '2em', color:'red', textAlign: 'left'}} xs='12'> {Classname} </Col>}
            </Row>
        </>
    );
};

ClassRow.propTypes = {
    data: PropTypes.object,
    pageState: PropTypes.object,
    classRec: PropTypes.object
};

const StudentTableComp = ({data, pageState}) => {
    const [canSave, setCanSave] = useState(false);
    const [isSaving, setIsSaving] = useState(false);

    useEffect(()=>{
        let testCanSave = data.studentData.reduce((acc,studRec)=>{
            if(studRec.isSelected)
                acc = true;
            return acc;
        },false);
        setCanSave(testCanSave);
    },[data.studentData]);

    useEffect(()=>{
        if(isSaving){
            if(pageState.database.queryCount == 0){
                setIsSaving(false);

                // reload the current classes students incase you want them next time
                let classID = data.classData.reduce((acc,classRec)=>{
                    if(classRec.isSelected)
                        acc = classRec.ClassID;
                    return acc;
                },'');
                let getStudentsForClass={
                    params: classID,
                    func:'getStudentsForClass',
                    altName: 'getStudentsForClassForLinkedStudentWindow'         
                };
                pageState.request(getStudentsForClass);

                pageState.deleteThis('getStudentsForClass');
                pageState.showStudentScreen();            
            }
        }
    },[pageState.database.queryCount]);

    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='6'>Name</Col>
    </Row>;

    //const displayLinkWindow = () => {pageState.linkStudentComp.setShowLinkStudentComp(false);};
    const displayLinkWindow = () => {pageState.showStudentScreen();};

    const attachStudents=()=>{
        let selectedStudents = data.studentData.filter(studRec=>studRec.isSelected);
        let nextState = data.studentData.map(e=>{e.isSelected=false; return e;});
        data.setStudentData(nextState);

        let otherClass = data.classData.find(e=>e.isSelected);
        let saveChanges = selectedStudents.map(studRec=>{
            let selectedClassID = pageState.showStudentTableComp.classInfo.ClassID;            
            return {debug:'Linking Students', func:'attachStudent', params: `${studRec.StudentID}~${selectedClassID}~${otherClass.Classname}`};
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSaving(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;

            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }
    };
    
    return (<>
        <Container>
            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='6'><h3>Select Students</h3></Col>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='6'>
                <span className={'pull-right'}>
                {(!isSaving)&&<><Button variant="danger" onClick={()=>displayLinkWindow()}>Cancel</Button> &nbsp;</>}
                </span>    
                </Col>  
            </TitleBar>
        </Container>
        {(isSaving)?<><Spinner/> <center>Saving...({pageState.database['queryCount']})</center></>: <>            
            <div style={{overflowY:'scroll', overflowX : 'hidden', height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
                {titleRow}
                {(pageState.database['queryCount']!==0) ? <Spinner/>:<>
                    {data.studentData.map((studRec, i) => 
                        <StudentRow key={i} pageState={pageState} studRec={studRec} data={data} />
                    )}
                </>}
            </div>
            <br/>
            <Row>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='12'>
                    <span className={'pull-right'}>
                        <Button onClick={attachStudents} disabled={!canSave} variant="success">Attach Student</Button> &nbsp;
                    </span>    
                </Col>  
            </Row>
        </>}        
        <br/>      
    </>
    );
};

StudentTableComp.propTypes = {
    data: PropTypes.object,
    pageState: PropTypes.object
};

const StudentRow = ({pageState, studRec, data}) => {
    const {Name, StudentID, attachID, isSelected} = studRec;
    const [canSelect, setCanSelect] = useState(true);

    useEffect(()=>{
        (attachID)?setCanSelect(false):setCanSelect(true);
    },[StudentID]);

    const toggleSelect = (studentID) => {
        let nextState = [...data.studentData];
        let studentIdx = nextState.findIndex(el => el.StudentID === studentID);
        nextState[studentIdx] = {...nextState[studentIdx], isSelected:!nextState[studentIdx].isSelected};
        data.setStudentData(nextState);
    };

    const rowStyle = {
        backgroundColor: (isSelected ? 'lightblue' : 'white'), 
        margin: '2px', 
        borderBottom: '1px solid #cfcfcf'
    };
    
    return (
        <>
            <Row style={rowStyle}><>
                {canSelect && <Col onClick={() => toggleSelect(StudentID)} style={{paddingLeft: '2em', cursor: 'pointer', textAlign: 'left'}} xs='12'> <IconSelected isSelected={isSelected}/> &nbsp; {Name} </Col>}
                {!canSelect && <Col style={{paddingLeft: '2em', color:'red', textAlign: 'left'}}> <IconClose/> &nbsp; {Name} </Col>}
            </></Row>
        </>
    );
};

StudentRow.propTypes = {
    data: PropTypes.object,
    studRec: PropTypes.object
};
export default LinkStudentComp;